import { Component, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { WindowBase } from '../../services/window-dialogs/window.base';
import { TicketWindowTypes } from '../../../app/dialog-windows/ticket/ticket.window';
import { TicketManager } from '../../../app/managers/ticket.manager';
import { CustomTicketItem, TicketStatusTypes, TicketUrgencyTypes } from '../../../app/models/domain/custom.ticket.item';
import { Subscription } from 'rxjs';
import { MemberDashboard } from '../../../app/models/ss-api/responses/member.dashboard.response';
import { TemplatesAndFromResponse } from '../../../app/models/ss-api/responses/templates.and.from.response';
import { SelectItem } from 'primeng/primeng';
import { TemplateSelectionComponent } from '../../../app/shared/components/template.selection/template.selection.component';
import { DialogService } from '../../../app/services/modal-dialogs';
import { Title } from '@angular/platform-browser';
import { GlobalService } from '../../../app/services/global.service';
import { ssApiService } from '../../../app/services/ss-api.service';
import { AdminHistoryService } from '../../../app/services/admin.history.service';
import { SweetAlertService } from "ng2-cli-sweetalert2";
import { AddCustomTicketRequest } from '../../../app/models/ss-api/requests/add.custom.ticket.request';
import { WindowEvent, WindowActionTypes } from '../../../app/services/window-dialogs/window.event';
import { CKEditorComponent } from 'ng2-ckeditor';

export class TicketAddWindowData {
  MemberOptions : SelectItem[];
  SelectedMemberID : number;
}

@Component({
  selector: 'ticket-add-window',
  styleUrls:  ['./ticket.add.window.scss'],
  templateUrl: './ticket.add.window.html'
})
export class TicketAddWindow extends WindowBase<TicketAddWindowData> implements OnDestroy {

  @ViewChild(TemplateSelectionComponent) TemplatePanel: TemplateSelectionComponent;
  @ViewChild('CKEDITOR') CKEDITOR: CKEditorComponent;

  ticketManager: TicketManager;

  //gb : GlobalService;

  TicketMemberID: number;
  CanSelectMember: boolean = true;

  IsBusy: Boolean = false;

  //browser Title
  private originalTitle: string;
  //subscriptions
  private ticketOnMemberAssign: Subscription;
  private ticketOnMemberUnassign: Subscription;


  assignToMember: boolean = false;

  Subject: string = "";
  Body: string = "";

  DueDate: Date = new Date();
  IsInternal: boolean = true;

  Status: TicketStatusTypes = TicketStatusTypes.New;

  SendEmail: boolean = false;


  // FORM ELEMENTS
  UserOptions: SelectItem[];
  SelectedUser: number;

  status: SelectItem[];
  selectedStatus: number;

  StatusOptions: SelectItem[];

  UrgencyOptions: SelectItem[];
  SelectedUrgency: number;

  // EMAIL TEMPLATE STUFF
  MemberData: MemberDashboard = new MemberDashboard();
  TemplatesAndFrom: TemplatesAndFromResponse = new TemplatesAndFromResponse();
  emailTemplate: string = "";
  emailTemplatePanel: boolean = false;

  MemberOptions: SelectItem[];
  SelectedMemberID: number = 0;
  notificationEmail: string;


  // CKEditor Config
  /*
  private CKEditorConfig = {
    allowedContent: true,
    height: 'calc(100% - 104px)',
    resize_enabled: false,
  }
  */


  // CKEditor Config
  private CKEditorConfig = {
    allowedContent: true,
    resize_enabled: false,
    height: '100%',
    toolbarLocation: 'bottom'
  }

  constructor(dialogService: DialogService,
    private titleService: Title,
    private changeDetect: ChangeDetectorRef,
    private gb: GlobalService,
    private api: ssApiService,
    private sweetAlertService: SweetAlertService,
    public historyService: AdminHistoryService,
    private cdRef: ChangeDetectorRef)
  {
    super();
  }


  ngOnDestroy() {

  }


  Init() {
    
    this.gb = this.Context.GlobalService;
    
    this.InitUserOptions();
    this.InitStatusOptions();
    this.InitUrgencyOptions();
    this.InitMemberOptions();

  }

  InitMemberOptions() {
    this.MemberOptions = [];
    
    console.log("this.gb =", this.gb);
    console.log("Context: ", this.Context);
    
    if( this.Context.Data.SelectedMemberID != undefined && this.Context.Data.SelectedMemberID != null )
      this.SelectedMemberID = this.Context.Data.SelectedMemberID;

    if(this.Context.Data.MemberOptions != undefined && this.Context.Data.MemberOptions != null)
      this.MemberOptions = this.Context.Data.MemberOptions;

  }

  async GetMemberData() {
    console.log("GetMemberData Started.", this.Context.Data);
    await this.api.getMemberDashboard( 0 ).toPromise().then( (result) => {
        if (!result.Result) {
          console.log("error while loading dashboard data", result);
          return;
        }
        console.log("Dashboard data received", result);
        this.MemberData = result.Data;
      }).catch( (error: any) => {
        console.log(error);
      });
  }

  confirm() {

    if(this.CKEDITOR.instance['mode'] != 'wysiwyg') {
              
        this.CKEDITOR.instance['commands']['source'].exec()
        setTimeout(() => {
            this.confirm();
        }, 500)

        return false;

    }

    let request = new AddCustomTicketRequest();

    request.AdminID = this.SelectedUser;
    request.MemberID = this.SelectedMemberID;
    request.IsInternal = this.IsInternal;
    request.DueDate = this.DueDate;
    request.CreatedByAdmin = true;
    request.FromEmail = this.gb.Email;
    request.Status = this.selectedStatus;
    request.Urgency = this.SelectedUrgency;
    request.Subject = this.Subject;
    request.Body = this.Body;
    request.IsHTMLBody = true;
    request.SendEmail = this.SendEmail;
    request.NotificationEmail =  this.notificationEmail;

    console.log("new request = ", request);

    //this.closeOK();
    this.sweetAlertService.swal({
      title: "Create New Ticket?",
      text: "Are you sure you want to create this new ticket?",
      type: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      closeButtonTextContent: "x",
      preConfirm: () => {
        //addcard
        return this.api.AddCustomTicket(request).toPromise()
      }
    })
      .then(
        async (response) => {

          if (!response.Result) {
            console.log("Error:", response);
            this.sweetAlertService.swal(
              {
                title: "Error",
                text: "Error adding Ticket",
                type: "error",
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'Ok',
              })
              .then(() => {
                this.Close();
               }, () => { this.Close(); }); //keep this line to prevent promise error;
            return;
          }


          //show confirmation
          this.sweetAlertService.swal(
            {
              title: "Success",
              text: "Ticket was succesfully added",
              type: "success",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1500
            })
            .then(() => {
              this.closeOK();
            }, () => { this.closeOK(); }); //keep this line to prevent promise error;

          
        },
        (dismiss) => {
          if (dismiss === 'cancel') {

            if (!confirm)
              return;

            //show cancelled
            this.sweetAlertService.swal({
              title: 'Cancelled',
              text: 'No changes are saved.',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1000
            }).then(() => {
              this.Close();
            }, () => { }); //keep this line to prevent promise error;
          }
        }).catch(error => {
          console.log(error);
          this.sweetAlertService.swal(
            {
              title: "Error",
              text: error.message,
              type: 'error',
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: 'OK',
            })
            .then((response: any) => {
              console.log("response", response);
              
              this.Close();
            }, (dismiss) => {
              console.log("dismissed");
              //this.IsBusy = false;
              return;
            }); //keep this line to prevent promise error;
        });

  }

  Relation(): string {
    if (this.ticketManager.Ticket().MemberID == -1) {
      return "Admin Name: ";
    }
    else if (this.ticketManager.Ticket().MemberID == 0) {
      return "Lead Name: ";
    }
    else {
      return "Member Name: ";
    }
  }

  closeOK() {
    // we set dialog result as true on click on confirm button, 
    // then we can get dialog result from caller code 
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, true));
    this.Close();

  }

  showEmailTemplatePanel() {
    console.log("Ticket Dialog is showing the email template panel!!!!!");
    this.emailTemplatePanel = true;
  }


  cancelEmailTemplate() {
    this.emailTemplatePanel = false;
  }

  StatusChanged(e: any) {
    console.log(e);
  }

  InitUserOptions() {
    this.UserOptions = [];

    console.log("ALL MY ADMINS!#$", this.gb.AllAdmins);

    this.gb.AllAdmins.forEach(x => {
      if (x.AdminID == this.gb.AdminId || x.FirstName == "API")
        return;
      this.UserOptions.push({ label: x.FirstName + " " + x.LastName, value: x.AdminID });
    });

    this.UserOptions.sort((left, right) => {
      if(left.label > right.label) {
        return 1;
      } else {
        return -1;
      }
    })
    
    this.UserOptions.unshift({ label: "Me - " + this.gb.FullName, value: this.gb.AdminId });
    this.UserOptions.unshift({ label: "Don't Assign", value: 0 });

    this.SelectedUser = this.gb.AdminId;
    this.notificationEmail = this.gb.Email;
  }

  InitStatusOptions() {

    this.StatusOptions = [];

    this.StatusOptions.push({ label: "New", value: TicketStatusTypes.New });
    this.StatusOptions.push({ label: "In Progress", value: TicketStatusTypes.InProgress });

    this.StatusOptions.push({ label: "Awaiting Member", value: TicketStatusTypes.AwaitingMemberResponse });
    this.StatusOptions.push({ label: "Awaiting Admin", value: TicketStatusTypes.AwaitingAdminResponse });
    this.StatusOptions.push({ label: "TOS", value: TicketStatusTypes.TOS });

    this.StatusOptions.push({ label: "Closed", value: TicketStatusTypes.Closed });

  }



  MemberSelectChanged() {
    console.log("Selected Member ID: " + this.SelectedMemberID);
    if (this.SelectedMemberID == -1)
      this.SendEmail = false;
  }

  InitUrgencyOptions() {
    this.UrgencyOptions = [];
    this.UrgencyOptions.push({ label: "Low", value: TicketUrgencyTypes.Low });
    this.UrgencyOptions.push({ label: "Normal", value: TicketUrgencyTypes.Normal });
    this.UrgencyOptions.push({ label: "High", value: TicketUrgencyTypes.High });
    this.UrgencyOptions.push({ label: "Super High", value: TicketUrgencyTypes.SuperHigh });
  }

  UrgencyChanged() {
    console.log("Urgency changed to " + this.SelectedUrgency);
  }

  AdminChanged(index: number) {
    console.log("AdminChanged - ", index);
    this.notificationEmail = this.gb.AllAdmins[index - 1].Email;
  }


  async showSelectEmailTemplate(e: any) {
    this.IsBusy = true;
    console.log("showSelectEmailTemplate");

    if (this.SelectedMemberID != 0) {

      await this.api.getMemberDashboard(this.SelectedMemberID).toPromise().then(response => {
        console.log("data received from my new promise!", response);
        this.MemberData = response.Data;
      }, error => {
        console.log(error);
      });

    }


    if (this.isTemplatesEmpty()) {
      let response = await this.api.GetEmailTemplatesBasicsAndFrom().toPromise();
      if (response.Result) {
        this.TemplatesAndFrom = response.Data;
        console.log("I PROMISE!!! All the other stuff has happened", this.TemplatesAndFrom.Templates);
      } else {
        console.log("Error", response.Message);
      }
    }

    this.IsBusy = false;

    this.emailTemplatePanel = true;
    console.log("show email panel = " + this.emailTemplatePanel);
    this.cdRef.detectChanges();
  }

  isTemplatesEmpty(): boolean {
    if (this.TemplatesAndFrom == null || this.TemplatesAndFrom == undefined)
      return true;
    else if (this.TemplatesAndFrom.Templates == null || this.TemplatesAndFrom.Templates == undefined || this.TemplatesAndFrom.Templates.length == 0)
      return true;
    else
      return false;
  }


  updateEmailTemplate(newTemplate: string) {
    this.emailTemplate = newTemplate;
    this.Body = this.emailTemplate;
    this.emailTemplatePanel = false;
  }

  updateEmailAddress(newEmailAddress: string) {
    //this.emailTo = newEmailAddress;
  }

  updateSubject(newSubject: string) {
    this.Subject = newSubject;
  }


  Close() {
    this.InvokeEvent(WindowEvent.FromWindowContextResultOK(this.Context, WindowActionTypes.Saved, true));
    window.close();
  }

}